import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import api from "./api";
import Moralis from "moralis";
import VueLazyLoad from 'vue3-lazyload'
import Toast, {POSITION} from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";


Moralis.start({
  apiKey: process.env.VUE_APP_MORALIS_API_KEY,
});


const app = createApp(App);
app.config.ignoredElements = [/^ion-/];
app.use(Toast, {
  position: POSITION.BOTTOM_CENTER
});

app.use(store);
app.use(VueLazyLoad, {
  // options...
})
app.use({
  install(app) {
    app.config.globalProperties.$http = api;
  },
});
app.mount("#app");
